import CounterModel from '@/Modules/Counter/CounterModel.js'
import axios from 'axios'

export default class CounterService {
  static list = ({ parameters, filters }) =>
    axios.get(`/counters${filters}`, {
      params: parameters,
      excludeLoader: true,
    })

  static update = (id, payload) => axios.put(`/counters/${id}`, payload)
  static show = id =>
    axios
      .get(`counters/${id}`)
      .then(response => new CounterModel(response.data?.data))
}
